const number_of_pictures = 20

export { number_of_pictures }